import React from "react";

import { ModalFooter, ModalHeader, ModalBody } from "./index.js";

const StudioModal = function(props) {
  let { modalHeader, modalBody, modalFooter, otherElements } = parseChildren(
    props.children,
  );

  let header = modalHeader || (
    <ModalHeader onCancel={props.onCancel} title={props.title} />
  );

  let body = modalBody || <ModalBody>{otherElements}</ModalBody>;

  let footer = modalFooter || (
    <ModalFooter
      onCancel={props.onCancel}
      cancelText={props.cancelText}
      onSave={props.onSave}
      saveText={props.saveText}
      dangerous={props.dangerous}
      loading={props.loading}
    />
  );

  let style = props.style || {};

  return (
    <div>
      <div className="modal-backdrop in" />

      <div
        id="modal-100002"
        className="modal in"
        style={{ zIndex: "100002", ariaHidden: "false", ...style }}
      >
        {header}

        {body}

        {footer}
      </div>
    </div>
  );
};

function parseChildren(children) {
  let modalHeader = null;
  let modalBody = null;
  let modalFooter = null;
  let otherElements = [];

  // Match on component identity, not component.type.name: the minifier renames
  // the ModalHeader/ModalBody/ModalFooter functions, so their runtime .name is a
  // mangled letter that never equals these labels. Comparing against the
  // imported references is minification-proof.
  React.Children.forEach(children, (component) => {
    try {
      switch (component.type) {
        case ModalHeader:
          modalHeader = component;
          break;
        case ModalBody:
          modalBody = component;
          break;
        case ModalFooter:
          modalFooter = component;
          break;
        default:
          otherElements.push(component);
          break;
      }
    } catch (err) {
      console.error(
        "Error. component or component.type undefined. This likely happened because you tried to inject custom components into the root level of the Modal. Custom jsx is only allowed within the <ModalHeader>, <ModalBody>, and <ModalFooter> sections.",
      );
    }
  });

  return {
    modalHeader: modalHeader,
    modalBody: modalBody,
    modalFooter: modalFooter,
    otherElements: otherElements,
  };
}

export default StudioModal;
